/*
 * @Description: 常见的工具类集合
 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-19 16:03:48
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2022-07-11 18:41:04
 */

import { BroadcastChannel, createLeaderElection } from 'broadcast-channel';
import classNames from 'classnames';

const channel = new BroadcastChannel('syzs_login', { type: 'localstorage' });
createLeaderElection(channel);

channel.onmessage = (info) => {
  if (!info) return;

  const { eventType, eventValue } = info || {};
  if (!eventType) return;

  void postMessageToParent(eventType, eventValue, false);
};

export const getUrlParam = (key: string): string | null => {
  const currentSearchValue = window.location.search?.substr(1);
  if (!currentSearchValue) return null;

  const paramReg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`, 'i');
  const r = currentSearchValue.match(paramReg);
  return r ? decodeURIComponent(r[2]) : null;
};

export const itemLoginTypeKey = 'itemLoginTypeKey';

export const postMessageToParent = async (eventType: string, eventValue: any, needChannel = true) => {
  window.parent?.postMessage({
    eventType,
    eventValue,
  }, '*');

  if (!needChannel) return;

  return channel.postMessage({
    eventType,
    eventValue,
  });
};

export const postMessageToOpener = async (eventType: string, eventValue: any) => {
  window.opener?.postMessage({
    eventType,
    eventValue,
  }, '*');
};

export const clearCookie = (name: string, domain: string, path: string) => {
  const today = (new Date()).getTime();
  document.cookie = `${name} =false; expires=${(new Date(today - 3600000 * 24 * 3)).toUTCString()}; ${path ? (`path=${path}; `) : 'path=/; '}${domain ? (`domain=${domain};`) : ('domain=qq.com;')}`;

  return true;
};

export const isMobile = () => {
  const search = new URLSearchParams(window.location.search);

  return search.get('isMobile') === '1';
};

export const getClientType = () => {
  const search = new URLSearchParams(window.location.search);

  return search.get('clientType');
};

export const getCoChannel = () => {
  const search = new URLSearchParams(window.location.search);

  return search.get('coChannel');
};

export const addMobileClassName = (className: string) => classNames(className, { 'is-mobile': isMobile() });

export const fill2Zero = (info: string) => (info.length < 2 ? `0${info}` : info);
